// Auto-scrolling certifications bar — adds credibility instantly
import { useLang } from "../contexts/LangContext";
import { CERTIFICATIONS } from "../data/certifications";
import { ShieldCheck, BadgeCheck, Lock, Building2, MapPin, Award } from "lucide-react";

const ICONS = {
  ihk: Building2,
  tuev: BadgeCheck,
  gdpr: Lock,
  insured: ShieldCheck,
  "made-in-germany": MapPin,
  "deutscher-mittelstand": Award
};

export default function CertificationsBar() {
  const { lang, t } = useLang();
  const ct = t.certifications;
  // Duplicate the list to enable seamless marquee
  const looped = [...CERTIFICATIONS, ...CERTIFICATIONS];

  return (
    <section
      className="py-10 lg:py-12 bg-[#090A0B] border-y border-neutral-800 overflow-hidden"
      data-testid="certifications-bar"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 mb-6">
        <div className="text-center">
          <p className="text-xs font-bold tracking-[0.25em] uppercase text-[#FF5A00] mb-2">
            {ct.eyebrow}
          </p>
          <h3 className="text-xl sm:text-2xl font-black tracking-tighter text-white">
            {ct.title}
          </h3>
        </div>
      </div>

      <div className="relative">
        <div className="flex animate-[scroll_38s_linear_infinite] gap-3 sm:gap-4">
          {looped.map((cert, idx) => {
            const Icon = ICONS[cert.id] || ShieldCheck;
            return (
              <div
                key={`${cert.id}-${idx}`}
                className="shrink-0 flex items-center gap-3 bg-white/5 border border-white/10 px-5 py-3.5 backdrop-blur-sm"
                data-testid={idx < CERTIFICATIONS.length ? `certification-${cert.id}` : undefined}
              >
                <div
                  className="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0"
                  style={{ background: `${cert.color}22`, color: cert.color }}
                >
                  <Icon size={16} />
                </div>
                <div className="min-w-0">
                  <div className="text-white font-black text-sm tracking-tight whitespace-nowrap">
                    {lang === "ar" ? cert.name_ar : cert.name}
                  </div>
                  <div className="text-neutral-400 text-[10px] tracking-wide leading-tight">
                    {lang === "ar" ? cert.description_ar : cert.description}
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Fade edges (use ltr/rtl-agnostic via logical positioning + linear-gradient) */}
        <div
          className="absolute inset-y-0 start-0 w-16 pointer-events-none"
          style={{ background: "linear-gradient(to right, #090A0B, transparent)" }}
        />
        <div
          className="absolute inset-y-0 end-0 w-16 pointer-events-none"
          style={{ background: "linear-gradient(to left, #090A0B, transparent)" }}
        />
      </div>
    </section>
  );
}
